const sixLawsImageModules = import.meta.glob('./**/*.{png,jpg,jpeg,svg}', {
  eager: true,
  import: 'default'
}) as Record<string, string>

export function getSixLawsImageUrl(imgSrc?: string): string {
  if (!imgSrc) return ''

  const normalizedPath = imgSrc.startsWith('/') ? `.${imgSrc}` : `./${imgSrc}`
  return sixLawsImageModules[normalizedPath] ?? ''
}
